import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { ContentCopyOutlined } from '@mui/icons-material';
import { FunctionComponent } from 'react';

/**
 * Building blocks of the cloud connect panels (AWS, Google Cloud): a labelled value with a copy
 * button, and a block of code or policy text with a copy button. What the vendor's admin copies
 * into their console or shell, shown the same way for every vendor.
 */

export const CopyRow: FunctionComponent<{ label: string, value: string, onCopy?: () => void }> = ({ label, value, onCopy }) => (
  <Stack direction='row' alignItems='center' spacing={2}>
    <Typography variant='subtitle1' sx={{ color: 'text.primary', minWidth: '160px' }}>{label}</Typography>
    <Typography variant='body2' sx={{ color: 'text.secondary', fontFamily: 'monospace', wordBreak: 'break-all', flex: 1 }}>{value}</Typography>
    {onCopy && (
      <Tooltip title='Copy'>
        <IconButton onClick={onCopy} aria-label={`Copy ${label}`}>
          <ContentCopyOutlined fontSize='small' />
        </IconButton>
      </Tooltip>
    )}
  </Stack>
);

export const CodeBlock: FunctionComponent<{ title: string, text: string, onCopy: () => void }> = ({ title, text, onCopy }) => (
  <Stack spacing={1}>
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Typography variant='subtitle1' sx={{ color: 'text.primary' }}>{title}</Typography>
      <Button variant='text' startIcon={<ContentCopyOutlined fontSize='small' />} onClick={onCopy} disabled={!text}>
        <Typography sx={{ pl: 0.5 }}>Copy</Typography>
      </Button>
    </Stack>
    <Box component='pre' sx={{
      m: 0, p: 2, borderRadius: '10px', backgroundColor: 'lightGrey.light', overflowX: 'auto',
      fontFamily: 'monospace', fontSize: '12px', color: 'text.primary',
    }}>
      {text || 'Not available'}
    </Box>
  </Stack>
);
